// Optimized Request a Quote Feature

document.addEventListener('DOMContentLoaded', () => {
  initQuoteFeature();
  setupSingleProductButtonLogic();
});

function initQuoteFeature() {
  const productIdElement = document.querySelector('[data-product-id]');
  const nameField = document.getElementById('nameField');
  const skuField = document.getElementById('skuField');
  const producturlField = document.getElementById('producturlField');
  const productimgField = document.getElementById('productImg');
  const storeNameButton = document.getElementById('storeNameButton');
  const storedNamesElement = document.getElementById('storedNames');
  const deleteDataButton = document.getElementById('deleteDataButton');
  const buttonBlock = document.getElementById('buttonBlock');
  const productDescriptionf = document.getElementById('productDescription');
  const productSpecificationf = document.getElementById('productSpecification');

  let productId = productIdElement?.dataset.productId;
  let storedData = JSON.parse(localStorage.getItem('productData')) || [];

  function updateProductCount() {
    const countElement = document.getElementById('list-products-count');
    if (countElement) countElement.textContent = storedData.length;
  }

  function updateStoredNames() {
    if (!storedNamesElement) return;
    storedNamesElement.innerHTML = '';

    if (storedData.length === 0) {
      storedNamesElement.innerHTML = '<b>Add products to your list to Print to PDF.<br>There are currently no products in the list.</b><br>';
      const homeButton = document.createElement('a');
      homeButton.href = '/';
      homeButton.textContent = 'Shop Now';
      homeButton.classList.add('home-button');
      storedNamesElement.appendChild(homeButton);
      if (buttonBlock) buttonBlock.style.display = 'none';
      return;
    }

    if (buttonBlock) buttonBlock.style.display = 'flex';

    storedData.forEach(productData => {
      const productContainer = document.createElement('div');
      productContainer.classList.add('product-data-container');

      const imageSkuContainer = document.createElement('div');
      imageSkuContainer.classList.add('image-sku-container');

      if (productData.featuredImage) {
        const featuredImageLink = document.createElement('a');
        featuredImageLink.href = productData.url;
        featuredImageLink.target = '_blank';
        const featuredImageElement = document.createElement('img');
        featuredImageElement.src = productData.featuredImage;
        featuredImageElement.setAttribute('width', '100');
        featuredImageLink.appendChild(featuredImageElement);
        imageSkuContainer.appendChild(featuredImageLink);
      }

      const productContentBlock = document.createElement('div');
      productContentBlock.classList.add('product-content-block');
      const productNameLink = document.createElement('a');
      productNameLink.href = productData.url;
      const productNameElement = document.createElement('p');
      productNameElement.textContent = productData.names;
      productNameElement.classList.add('names-container');
      productNameLink.appendChild(productNameElement);
      productContentBlock.appendChild(productNameLink);
      const productSkuElement = document.createElement('p');
      productSkuElement.textContent = `#${productData.skus}`;
      productContentBlock.appendChild(productSkuElement);

      imageSkuContainer.appendChild(productContentBlock);
      productContainer.appendChild(imageSkuContainer);

      const titleNamesContainer = document.createElement('div');
      titleNamesContainer.classList.add('title-names-container');
      const namesList = document.createElement('ul');
      const listItem = document.createElement('li');
      listItem.classList.add('remove-list');
      listItem.textContent = productData.names;
      const deleteButton = document.createElement('button');
      deleteButton.textContent = 'Remove';
      deleteButton.classList.add('delete-button');
      deleteButton.addEventListener('click', function () {
        storedData = storedData.filter(p => p.id !== productData.id);
        localStorage.setItem('productData', JSON.stringify(storedData));
        updateStoredNames();
        updateProductCount();
      });
      listItem.appendChild(deleteButton);
      namesList.appendChild(listItem);
      titleNamesContainer.appendChild(namesList);
      productContainer.appendChild(titleNamesContainer);

      storedNamesElement.appendChild(productContainer);
    });

    updateProductCount();
  }

  function handleButtonClick() {
    const productData = {
      id: productId,
      names: nameField.value,
      skus: skuField.value,
      url: producturlField.value,
      featuredImage: productimgField.value,
      productDescription: productDescriptionf.value,
      productSpecification: productSpecificationf.value
    };

    if (!storedData.some(p => p.id === productId)) {
      storedData.push(productData);
      localStorage.setItem('productData', JSON.stringify(storedData));
      storeNameButton.disabled = true;
      storeNameButton.classList.add('disable');
      storeNameButton.textContent = 'Added to List';
      updateStoredNames();
      updateProductCount();
    }
  }

  function deleteStoredData() {
    localStorage.removeItem('productData');
    storedData = [];
    updateStoredNames();
    updateProductCount();
  }

  storeNameButton?.addEventListener('click', handleButtonClick);
  deleteDataButton?.addEventListener('click', deleteStoredData);

  updateStoredNames();
  updateProductCount();

  if (storedData.some(p => p.id === productId)) {
    storeNameButton.disabled = true;
    storeNameButton.classList.add('disable');
    storeNameButton.textContent = 'Added to List';
  }
}

function setupSingleProductButtonLogic() {
  function updateButtonStates() {
    const buttons = document.querySelectorAll('button.storeNameButtonsingle');
    const storedData = JSON.parse(localStorage.getItem('productData')) || [];

    buttons.forEach(button => {
      const productCard = button.closest('.product-section');
      const productId = productCard?.dataset.productId;
      const isProductInStorage = storedData.some(p => p.id === productId);

      button.textContent = isProductInStorage ? 'Added to List' : 'Add to List';
      button.disabled = isProductInStorage;
      button.classList.toggle('disable', isProductInStorage);
    });
  }

  document.body.addEventListener('click', function (event) {
    if (event.target.matches('button.storeNameButtonsingle')) {
      const button = event.target;
      const productCard = button.closest('.product-section');
      const productId = productCard?.dataset.productId;

      const productData = {
        id: productId,
        names: productCard.querySelector('.nameField')?.value,
        skus: productCard.querySelector('.skuField')?.value,
        url: productCard.querySelector('.producturlField')?.value,
        featuredImage: productCard.querySelector('.productImg')?.value,
        productDescription: productCard.querySelector('.productDescription')?.value,
        productSpecification: productCard.querySelector('.productSpecification')?.value
      };

      let storedData = JSON.parse(localStorage.getItem('productData')) || [];

      if (!storedData.some(p => p.id === productId)) {
        storedData.push(productData);
        localStorage.setItem('productData', JSON.stringify(storedData));
        button.textContent = 'Added to List';
        button.disabled = true;
        button.classList.add('disable');
        const countElement = document.getElementById('list-products-count');
        if (countElement) countElement.textContent = storedData.length;
      } else {
        alert('Product is already in the list');
      }
    }
  });

  let updateTimeout;
  const observer = new MutationObserver(() => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(updateButtonStates, 500);
  });

  const productContainer = document.querySelector('#filter-results');
  if (productContainer) {
    observer.observe(productContainer, { childList: true, subtree: true });
  }

  updateButtonStates();

  const loadMoreButton = document.querySelector('.pagination-load-more');
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
      setTimeout(updateButtonStates, 1000);
    });
  }
}
